import type {
  MarketplaceProfile,
  MarketplaceProfileStatus,
  UpsertMarketplaceProfileDto,
} from '@foodfluence/shared';
import { localPackageToApiRow, apiPackageToLocalRow } from './packageMapping';
import { profileImageToAssetRef, topSlotsToAssets } from './marketplaceProfileAssets';
import { MARKETPLACE_BIO_MAX_CHARS } from './marketplaceProfileDefaults';
import type { LocalCreatorsPackageRow } from '../types';
import type { MarketplaceProfilePatch } from './marketplaceProfileTypes';

export { MARKETPLACE_BIO_MAX_CHARS };

export function buildMarketplaceProfileUpsertDto(
  patch: MarketplaceProfilePatch
): UpsertMarketplaceProfileDto {
  const dto: UpsertMarketplaceProfileDto = {};

  if ('bio' in patch) {
    const bioTrim = (patch.bio ?? '').trim();
    if (bioTrim.length <= MARKETPLACE_BIO_MAX_CHARS) {
      dto.bio = bioTrim;
    }
  }

  if ('slug' in patch) {
    const sl = (patch.slug ?? '').trim();
    if (sl !== '') {
      dto.slug = sl;
    }
  }

  if ('turnaround' in patch && patch.turnaround) {
    dto.turnaroundTime = patch.turnaround;
  }

  if ('marketplaceBrands' in patch) {
    dto.brands = patch.marketplaceBrands ?? [];
  }

  if ('packages' in patch) {
    dto.packages = (patch.packages ?? []).map((p) => localPackageToApiRow(p));
  }

  if ('topSlots' in patch) {
    dto.assets = topSlotsToAssets(patch.topSlots ?? []);
  }

  if ('profileImage' in patch) {
    dto.profileImage = patch.profileImage ? profileImageToAssetRef(patch.profileImage) : null;
  }

  if ('isAccountActive' in patch) {
    const status: MarketplaceProfileStatus = patch.isAccountActive ? 'published' : 'draft';
    dto.status = status;
  }

  if (patch.deactivationReason !== undefined) {
    dto.deactivationReason = patch.deactivationReason;
  }

  return dto;
}

export function packagesFromProfileList(
  packages: MarketplaceProfile['packages']
): LocalCreatorsPackageRow[] {
  if (!packages?.length) {
    return [];
  }
  return packages.map((p) => apiPackageToLocalRow(p));
}
